import * as React from 'react'

import { observer } from 'mobx-react'

import { dateToString, stringToDate } from 'modules/core/lib/dates'
import centsToDecimal from 'modules/core/lib/formatCents'

import Item from 'modules/contracts/components/ContractDetails/OtherContractInformation/Item'
import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'
import type CustomFieldValue from 'modules/custom_resources/store/models/customFields/Value'

interface Props {
  customField: ResourceField
  customValue?: CustomFieldValue
}

const CustomField = ({ customField, customValue }: Props) => {
  const value = customValue?.attributes.value
  let description = undefined
  if (value !== undefined) {
    switch (customField.attributes.field_type) {
      case FieldTypes.text:
      case FieldTypes.longText:
      case FieldTypes.singleChoice:
        description = value
        break
      case FieldTypes.cents:
        if (value) {
          description = centsToDecimal(value).toString()
        }
        break
      case FieldTypes.date:
        if (value) {
          description = dateToString(stringToDate(value, 'backend'), 'ui_dmy_long')
        }
        break
    }
  }

  return <Item title={customField.attributes.label} description={description} />
}

export default observer(CustomField)
